module.exports = __webpack_public_path__ + "img/cns_ios6.45fd5064.png";